import "core-js/modules/es.array.push.js";
export default {
  data() {
    return {
      isShow: false,
      selectIndex: '',
      activeIndex: "/home",
      routerList: [{
        routerName: "首页",
        id: "1",
        path: "/home"
      }, {
        routerName: "商品管理",
        id: "2",
        path: "/goods",
        child: [{
          routerName: "商品查询",
          id: "2-1",
          path: "/goods-search"
        }, {
          routerName: "购物车",
          id: "2-2",
          path: "/goods-cart"
        }, {
          routerName: "上传需求单",
          id: "2-3",
          path: "/goods-upOrder"
        }, {
          routerName: "智能配单",
          id: "2-5",
          path: "/goods-IntelligentOrdering"
        }, {
          routerName: "需求单管理",
          id: "2-4",
          path: "/goods-odManagement",
          child: [{
            routerName: "用户上传详情",
            id: "2-4-1",
            path: "/goods-odManagement-detail"
          }, {
            routerName: "智能配单详情",
            id: "2-4-2",
            path: "/goods-IntelligentOrdering-detail"
          }]
        }]
      }, {
        routerName: "订单管理",
        id: "3",
        path: "/order",
        child: [{
          routerName: "订单查询",
          id: "3-1",
          path: "/order-search",
          child: [{
            routerName: "订单详情",
            id: "3-1-1",
            path: "/order-search-detail"
          }, {
            routerName: "退货退款",
            id: "3-1-2",
            path: "/order-search-returns"
          }]
        },
        // {
        //   routerName: "批销单查询",
        //   id: "3-2",
        //   path: "/order-wholesale",
        //   child:[
        //     {
        //       routerName: "批销单详情",
        //       id: "3-2-1",
        //       path: "/order-wholesale-detail",
        //     }
        //   ]
        // },
        // {
        //   routerName: "分包单查询",
        //   id: "3-3",
        //   path: "/order-subcontract",
        //   child:[
        //     {
        //       routerName: "分包单详情",
        //       id: "3-3-1",
        //       path: "/order-subcontract-detail",
        //     }
        //   ]
        // },
        // {
        //   routerName: "发运单查询",
        //   id: "3-4",
        //   path: "/order-send",
        //   child:[
        //     {
        //       routerName: "发运单详情",
        //       id: "3-4-1",
        //       path: "/order-send-detail",
        //     }
        //   ]
        // },
        {
          routerName: "合同申请",
          id: "3-5",
          path: "/order-contractApply"
        }, {
          routerName: "售后查询",
          id: "3-6",
          path: "/order-afterService"
        }, {
          routerName: "发票管理",
          id: "3-7",
          path: "/order-invoice"
        }
        // Invoice
        ]
      }, {
        routerName: "企业管理",
        id: "4",
        path: "/enterprise",
        child: [
        // {
        //   routerName: "保证金管理",
        //   id: "4-1",
        //   path: "/enterprise-myCredit",
        // },
        {
          routerName: "地址管理",
          id: "4-2",
          path: "/enterprise-addressManagement"
        }, {
          routerName: "成员管理",
          id: "4-3",
          path: "/enterprise-memberManagement"
        }, {
          routerName: "企业维护",
          id: "4-4",
          path: "/enterprise-maintain"
        }, {
          routerName: "账期结算",
          id: "4-5",
          path: "/enterprise-deliveryBeforePayment"
        }]
      }],
      // 业务流程
      showBusinessProcess: false,
      processBoxShow: false,
      processList: [],
      processCode: '' //选中的业务流程
    };
  },

  mounted() {
    this.getExplainPage();
    // 扁平化菜单数组并存入缓存
    let routerListFlat = this.flatten(this.routerList);
    localStorage.setItem("routerListFlat", JSON.stringify(routerListFlat));

    // 此处暂时注释掉普通用户登录之后只能展示企业认证页的判断，配合下方注释掉的handleSelect方法一起使用
    // if(this.$store.state.user.userType == 0){
    //   this.selectIndex = '/enterprise-bindingBusiness'
    //   this.activeIndex = '/enterprise-bindingBusiness'
    // }
  },

  methods: {
    //扁平化菜单
    flatten(arr) {
      let result = [];
      arr.forEach(item => {
        result.push(item);
        if (Array.isArray(item.child)) {
          result = result.concat(this.flatten(item.child));
        }
      });
      return result;
    },
    // 登录之后必须认证才可以查看企业认证以外的其他功能 由于普通用户也可以查看首页和商品查询 所以暂时注释掉，搭配上方挂载注释掉的判断
    // handleSelect(key, keyPath) {
    //   console.log(key, keyPath);
    //   this.selectIndex = key
    //   if(this.$store.state.user.userType == 0){
    //     this.selectIndex = '/enterprise-bindingBusiness'
    //     this.activeIndex = '/enterprise-bindingBusiness'
    //     this.$refs.menu.activeIndex = this.activeIndex
    //     this.$message({ type: "warning",message: "您还未进行认证，不允许操作当前系统，请先进行企业认证。。。",duration: 1500 })
    //   }else{
    //     this.$router.push(key)
    //   }
    // },

    // 暂时更改为此下方案
    handleSelect(key, keyPath) {
      this.selectIndex = key;
      if (!this.$store.state.token || !this.$store.state.token == "undefined") {
        if (key == '/home' || key == '/goods-search') {
          this.$router.push(key);
        } else {
          this.$message({
            type: "warning",
            message: "当前未登录，请先登录。。。",
            duration: 1500
          });
        }
      } else {
        if (!this.$store.state.user.userType || this.$store.state.user.userType == 0) {
          if (key == '/home' || key == '/goods-search' || key == '/enterprise-maintain') {
            this.$router.push(key);
          } else {
            this.$message({
              type: "warning",
              message: "您还未进行认证，不允许操作当前系统，请先进行企业认证。。。",
              duration: 1500
            });
          }
        } else if (this.$store.state.user.userType == 1) {
          this.$router.push(key);
        }
      }
    },
    // 业务流程展开收起
    toprocessbox() {
      this.processBoxShow = !this.processBoxShow;
      this.showBusinessProcess = !this.showBusinessProcess;
    },
    leaveprocessbox() {
      this.processBoxShow = false;
      this.showBusinessProcess = false;
      this.processCode = '';
    },
    // 获取流程菜单
    getExplainPage() {
      this.$axios.get("/p/common/explainPage").then(({
        data
      }) => {
        if (data.code == 200) {
          this.processList = data.data;
        } else {
          this.$message({
            type: "error",
            message: data.message,
            duration: 1500
          });
        }
      });
    },
    toProcess(item) {
      this.processCode = item.value;
      this.$axios.get(`/p/common/explainPage/${this.processCode}`).then(({
        data
      }) => {
        if (data.code == 200) {
          window.open(data.data, 'view_window');
        } else {
          this.$message({
            type: "error",
            message: data.message,
            duration: 1500
          });
        }
      });
    }
  },
  watch: {
    // 监视路由信息对象
    $route: {
      immediate: true,
      handler(route) {
        // 获取扁平化后的菜单数组
        let routerListFlat = JSON.parse(localStorage.getItem("routerListFlat") || []);
        // 获取当前菜单的唯一id  例如2-3-1
        let idArr = routerListFlat.filter(n => n.path == route.path);
        let id = "";
        if (idArr.length == 1) {
          id = idArr[0].id;
        }
        // 根据id获取完整菜单的id的数组  例如：[2,2-3,2-3-1]
        let routePathResult = [];
        let ids = id.split('-');
        for (let index = 0; index < ids.length; index++) {
          if (index == 0) {
            routePathResult.push(ids[index]);
          } else {
            routePathResult.push(routePathResult[index - 1] + '-' + ids[index]);
          }
        }
        let routeSelect = routerListFlat.filter(n => n.id == (routePathResult[1] || '1'))[0].path || '/home';
        this.selectIndex = routeSelect;
        this.activeIndex = routeSelect;
      }
    }
  }
};